module.exports = __webpack_public_path__ + "static/media/guest_consent.bb44b838.svg";